import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { CACHE_FOREVER, productTypeParam } from './priceQueries.utils';
import { useIsTldPriceCacheEnabled } from './useIsTldPriceCacheEnabled';
export const useSuggestedTldPrices = function (productType, enabled) {
  if (enabled === void 0) {
    enabled = true;
  }
  const isTldPriceCacheOn = useIsTldPriceCacheEnabled();
  return DomainsApiClient.hooks.useListSuggestedTldDisplayPrices(productTypeParam(productType), isTldPriceCacheOn && enabled, {
    ...CACHE_FOREVER,
    useErrorBoundary: false
  });
};
//# sourceMappingURL=useSuggestedTldPrices.js.map